import { logToAi } from '@/utils/logging.js';
import queue from './queue';

let _MAX_CONCURRENT_TASKS = 5;
let _id = Date.now();
const _queue = queue(_MAX_CONCURRENT_TASKS);

export const addToQueue = (task, taskName) => {
	return new Promise((resolve, reject) => {
		return _queue
			.add(_id + 1, task, 1, taskName, false)
			.then((res) => {
				logToAi(
					{
						message: `Successfully completed task in queue`,
						id: `REQUEST_QUEUE_SUCCESS`,
						location: 'requestQueue.js:addToQueue',
						data: {
							taskName,
						},
					},
					`info`
				);
				console.log('successfully completed', taskName);
				resolve(res);
			})
			.catch((err) => {
				logToAi(
					{
						message: `Failed to complete task in queue`,
						id: `REQUEST_QUEUE_FAILED`,
						location: 'requestQueue.js:addToQueue',
						data: {
							taskName,
							error: err,
						},
					},
					`error`
				);
				console.error('Failed to execute task', taskName, err);
				reject(err);
			});
	});
};
